var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable no-inner-declarations */
import { __isComponent } from '../AwsUi';
import logger from '../../../utils/src/logger';
import MithrilHelpers from '../MithrilHelpers';
import { createComponent } from '../embeddedComponents';
import addCustomFocus from './FocusHandling';
import { createElement, render } from '../mithril';
export var prototypeAdditions;
(function (prototypeAdditions) {
    function __update() {
        // Component will be rerendered when attached
        if (this.__componentState === 'detached') {
            return;
        }
        if (this.__updateBlocked) {
            this.__updateRequested = true;
            return;
        }
        this.__updateImmediately();
    }
    prototypeAdditions.__update = __update;
    function __updateImmediately() {
        var _this = this;
        this.__callBatchUpdate(function () {
            var helpers = new MithrilHelpers(_this);
            _this.__renderToMithrilKeys = [];
            render(_this.node, _this.__render(createElement, helpers));
            _this.__renderToMithrilKeys = [];
            _this.__updateRequested = false;
        });
    }
    prototypeAdditions.__updateImmediately = __updateImmediately;
    function __batchUpdate(callback) {
        var _this = this;
        this.__callBatchUpdate(function () {
            if (_this.__updateBlocked) {
                _this.__updateRequested = true;
                callback();
                return;
            }
            _this.__updateBlocked = true;
            _this.__updateRequested = false;
            callback();
            if (_this.__updateRequested) {
                _this.__updateImmediately();
            }
            _this.__updateBlocked = false;
        });
    }
    prototypeAdditions.__batchUpdate = __batchUpdate;
    function __destroy() {
        render(this.node, null);
        this.__updateRequested = false;
    }
    prototypeAdditions.__destroy = __destroy;
    function renderToMithril(lifecycleKey, renderable, data, elementName) {
        if (data === void 0) { data = []; }
        if (elementName === void 0) { elementName = 'span'; }
        if (this.__renderToMithrilKeys.indexOf(lifecycleKey) > -1) {
            // Wrappers use this keys to track and recycle renderable content between updates
            logger.error("Duplicate renderToMithril key: " + lifecycleKey + ". These keys must be unique within one component");
        }
        this.__renderToMithrilKeys.push(lifecycleKey);
        var wrapperRenderHooks = this.__getWrapperRenderHooks({
            renderable: renderable,
            data: data,
            lifecycleKey: lifecycleKey
        });
        if (wrapperRenderHooks === null) {
            return null;
        }
        var children = wrapperRenderHooks.children, attrs = __rest(wrapperRenderHooks, ["children"]);
        return createElement(elementName, __assign({ lifecycleKey: lifecycleKey }, attrs), children);
    }
    prototypeAdditions.renderToMithril = renderToMithril;
    function __getWrapperRenderHooks(_a) {
        var renderable = _a.renderable, data = _a.data;
        // Transform the data from [{a:'b'}, {c:'d'}] to ['b', 'd']
        var transformData = function (data) { return data.map(function (entry) { return entry[Object.keys(entry)[0]]; }); };
        var type = typeof renderable;
        var children;
        if (type === 'string') {
            children = renderable;
        }
        else if (type === 'function') {
            children = renderable.apply(void 0, transformData(data));
        }
        else {
            throw new Error("Unsupported parameter type \"" + type + "\"");
        }
        if (children === null || children === undefined) {
            return null;
        }
        return { children: children };
    }
    prototypeAdditions.__getWrapperRenderHooks = __getWrapperRenderHooks;
    // Used in React wrapper to suspend inner React updates while component is being re-rendered
    // No operation for other wrappers
    function __callBatchUpdate(updater) {
        updater();
    }
    prototypeAdditions.__callBatchUpdate = __callBatchUpdate;
})(prototypeAdditions || (prototypeAdditions = {}));
/**
 * Sets the render method for the component. Should
 * be a method that returns a mithril vdom. Arguments
 * are a mithril instance and a MithrilHelpers instance
 * @abstract
 */
export function extendComponent(customPrototype, definition) {
    customPrototype.__render = definition.render;
}
/**
 * Utility function for JSX syntax. Substitute of `m(element, arguments, ...children)`
 */
export function __createElement(element, attributes) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    if (__isComponent(element)) {
        if (children.length > 0) {
            logger.error('Adding default region using children argument ' + 'currenlty not supported for embedded components.');
            return;
        }
        return createComponent(element, attributes);
    }
    if (typeof element === 'function') {
        return element(attributes);
    }
    // Focusable attribute is added to the native element
    if (attributes && attributes.hasOwnProperty('override-focus')) {
        addCustomFocus(attributes);
    }
    return createElement.apply(void 0, __spreadArrays([element, attributes], children));
}
//# sourceMappingURL=RenderHandling.js.map